// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_kb-0";
export var fileCarousel = "_kb-2";
export var removeFileButton = "_kb-1";